import React, { useEffect, useState } from "react";

// ⬇️ MUI v5 imports (Option A – keep makeStyles)
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ButtonGroup from '@mui/material/ButtonGroup';

import { useSearchParams } from "react-router-dom";
import $ from 'jquery';
import './dataTables.css';
import './daterangepicker.css';
import daterangepicker from 'daterangepicker';
import moment from 'moment';
import printIcon from './icons/print.png';

$.DataTable = require('datatables.net');

var TestInvoices = [

    {
        "main_line": {
            "PAYMENT_TIMESTAMP": "01-11-2024",
            "PAYMENT_DESCRIPTION": "8400000027_20230113.PDF",
            "VALUE": 132.09,
            "AUTH_STATUS": "Überwiesen",
            "IS_FILE_EXIST": "INVOICES/8400000027_20230113.PDF"
        },
        "nested_lines": [
            {
                "PAYMENT_TIMESTAMP": null,
                "PAYMENT_DESCRIPTION": null,
                "VALUE": null,
                "CUSTOMER_CODE": "0002071335",
                "PAYMENT_ID": "SFAY999H00127429",
                "SOURCE_SYSTEM_NAME": "ISMS",
                "PAYMENT_REASON": "PAYMENT",
                "PAYMENT_COMMENT": "None",
                "INVOICE_ID": 8400000027,
                "INVOICE_NAME": "8400000027_20230113.PDF",
                "INVOICE_ID_RAW": "8400234777"
            },
            {
                "PAYMENT_TIMESTAMP": "12-01-2023",
                "PAYMENT_DESCRIPTION": "Vereinbarung Programm (POS-L) 22",
                "VALUE": 132.09,
                "CUSTOMER_CODE": "0002071335",
                "PAYMENT_ID": "SFAY999H00127429",
                "SOURCE_SYSTEM_NAME": "ISMS",
                "PAYMENT_REASON": "PAYMENT",
                "PAYMENT_COMMENT": "None",
                "INVOICE_ID": 8400000027,
                "INVOICE_NAME": "8400000027_20230113.PDF",
                "INVOICE_ID_RAW": "8400176777"
            }
        ]
    },
    {
        "main_line": {
            "PAYMENT_TIMESTAMP": "01-11-2024",
            "PAYMENT_DESCRIPTION": "8600002513_20240112.PDF",
            "VALUE": 55555.55,
            "AUTH_STATUS": "Überwiesen",
            "IS_FILE_EXIST": "INVOICES/8600002513_20240112.PDF"
        },
        "nested_lines": [
            {
                "PAYMENT_TIMESTAMP": "29-11-2023",
                "PAYMENT_DESCRIPTION": "Incentive Vergütung",
                "VALUE": 55555.55,
                "CUSTOMER_CODE": "0002071335",
                "PAYMENT_ID": "2SKU 7133048638",
                "SOURCE_SYSTEM_NAME": "Other",
                "PAYMENT_REASON": "INCVER",
                "PAYMENT_COMMENT": "SPEEDABO 3SKU",
                "INVOICE_ID": 860000251320240112,
                "INVOICE_NAME": "8600002513_20240112.PDF"
            }
        ]
    },
    {
        "main_line": {
            "PAYMENT_TIMESTAMP": "01-11-2024",
            "PAYMENT_DESCRIPTION": "8600002513_20240112.PDF",
            "VALUE": 0.00,
            "AUTH_STATUS": "In Bearbeitung",
            "IS_FILE_EXIST": "INVOICES/8600002513_20240112.PDF"
        },
        "nested_lines": [
            {
                "PAYMENT_TIMESTAMP": "29-11-2023",
                "PAYMENT_DESCRIPTION": "Incentive Vergütung",
                "VALUE": 55555.55,
                "CUSTOMER_CODE": "0002071335",
                "PAYMENT_ID": "2SKU 8237566512",
                "SOURCE_SYSTEM_NAME": "Other",
                "PAYMENT_REASON": "INCVER",
                "PAYMENT_COMMENT": "SPEEDABO 1SKU",
                "INVOICE_ID": 860000251320240112,
                "INVOICE_NAME": "8600002513_20240112.PDF"
            }
        ]
    },
    {
        "main_line": {
            "PAYMENT_TIMESTAMP": "22-06-2023",
            "PAYMENT_DESCRIPTION": "Incentive Vergütung",
            "VALUE": 15.0,
            "AUTH_STATUS": "In Bearbeitung",
            "IS_FILE_EXIST": null
        },
        "nested_lines": [
            {
                "PAYMENT_TIMESTAMP": "22-06-2023",
                "PAYMENT_DESCRIPTION": "Incentive Vergütung",
                "VALUE": 15.0,
                "CUSTOMER_CODE": "0002071335",
                "PAYMENT_ID": "DE03103756",
                "SOURCE_SYSTEM_NAME": "OPEN",
                "PAYMENT_REASON": "OPEN",
                "PAYMENT_COMMENT": "<u><span style=f",
                "INVOICE_ID": 2382343274,
                "INVOICE_NAME": null
            }
        ]
    },
    {
        "main_line": {
            "PAYMENT_TIMESTAMP": "28-02-2023",
            "PAYMENT_DESCRIPTION": "Incentive Vergütung",
            "VALUE": 35.0,
            "AUTH_STATUS": "In Bearbeitung",
            "IS_FILE_EXIST": null
        },
        "nested_lines": [
            {
                "PAYMENT_TIMESTAMP": null,
                "PAYMENT_DESCRIPTION": null,
                "VALUE": null,
                "CUSTOMER_CODE": "0002005484",
                "PAYMENT_ID": "SFRW50HHY0059224",
                "SOURCE_SYSTEM_NAME": "ISMS",
                "PAYMENT_REASON": "INCVERG",
                "PAYMENT_COMMENT": "Neueinführung HEE",
                "INVOICE_ID": null,
                "INVOICE_NAME": null
            }
        ]
    },
    {
        "main_line": {
            "PAYMENT_TIMESTAMP": "16-02-2023",
            "PAYMENT_DESCRIPTION": "P4P Auszahlung 02 2023",
            "VALUE": 35.0,
            "AUTH_STATUS": "In Bearbeitung",
            "IS_FILE_EXIST": null
        },
        "nested_lines": [
            {
                "PAYMENT_TIMESTAMP": null,
                "PAYMENT_DESCRIPTION": null,
                "VALUE": null,
                "CUSTOMER_CODE": "0002005484",
                "PAYMENT_ID": "CDR130/0110/0001",
                "SOURCE_SYSTEM_NAME": "P4P",
                "PAYMENT_REASON": "P4P",
                "PAYMENT_COMMENT": "Regist.: 4",
                "INVOICE_ID": null,
                "INVOICE_NAME": null
            }
        ]
    }
]

// config
var unitTestMode = false;
var devEndpoint = false;
// end config

var eventToHandle
var oTable
var functionsFlag = false
var settings_end_of_the_month_payment = 0
var monthly_payment_removed_date = 0
var monthly_payment_requested_date = 0
var filterSelectionsDict = { 0: [], 1: [], 2: [], 3: [], 4: [] }

var startDate = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).subtract(4, 'week')
var endDate = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })

if (sessionStorage.getItem("startDate") === null) {
    sessionStorage.setItem('startDate', startDate);
}
if (sessionStorage.getItem("endDate") === null) {
    sessionStorage.setItem('endDate', endDate);
}


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0),
    },
    paper: {
        padding: theme.spacing(0),
        color: theme.palette.text.secondary,
    },
}));

export default function InvoiceList() {
    const classes = useStyles();
    console.log("InvoiceList");
    const vars = window.location.search.substring(1).split('&');
    const [searchParams] = useSearchParams();
    const query = decodeURIComponent(searchParams.get("query"));
    var api_endpoint = "https://api-pmg-invoice.eu.acxiom.com";
    if (devEndpoint)
        api_endpoint = "https://api-pmg-invoice.eu.acxiom.com";
    const [invoices, setInvoices] = useState([]);
    const [settings, setSettings] = useState([]);
    const [functionsFlag, setFunctionsFlag] = useState(false)
    useEffect(() => {
        InvoiceGet()
    }, [])
    useEffect(() => {
        SettingsCall("GET", 3)
    }, [])

    function defineTable() {
        $(function () {
            oTable = $('#table_id').DataTable({
                "paging": false,
                "order": [[1, 'desc']],
                "bScrollCollapse": false,
                "bDestroy": true,
                
                "columnDefs": [
                    { orderable: false, targets: [0, 5] },
                    {
                        targets: 6,
                        searchable: true,
                        visible: false
                    },
                ],
                "language": {
                    search: "Suchen&nbsp;:",
                    info: "Sie sehen _END_ Einträge",
                    infoEmpty: "Sie sehen 0 von 0 gesamt",
                    infoFiltered: "(gefiltered von _MAX_ gesamt)",
                    infoPostFix: "",
                    loadingRecords: "Loading...",
                    zeroRecords: "keine Daten",
                    emptyTable: "keine Daten",
                },
            initComplete: function () {
                // ✅ Attach search handler to custom input next to date-range container
                $('.custom-search-input').off().on('keyup', function () {
                    document.querySelector('tbody').querySelectorAll('tr').forEach(function (row) {
                        if (row.classList.contains("expanded")) {
                            row.click();
                        }
                    });
                    oTable.search(this.value.trim(), false, false).draw();
                });
            }

            });
            $("th").off()
            
            
           

            var headers = document.querySelectorAll("th")
            var sortButtons = document.querySelectorAll(".sorter")
            var allArrows = document.querySelectorAll('.sorter')
            allArrows[1].style.opacity = '1';
            headers.forEach(function (header) {
                if (header.querySelector('.sortUp') != null) {
                    var upArrow = header.querySelector('.sortUp')
                    var downArrow = header.querySelector('.sortDown')

                    upArrow.onclick = function () {
                        document.querySelector('tbody').querySelectorAll('tr').forEach(function (row) {
                            if (row.classList.contains("expanded")) {
                                row.click()
                            }
                        })
                        oTable.order([[].indexOf.call(headers, header), 'asc']).draw()

                        allArrows.forEach(function (arrow) {
                            arrow.style.opacity = '0.3';
                        })
                        upArrow.style.opacity = '1';
                    };
                    downArrow.onclick = function () {
                        document.querySelector('tbody').querySelectorAll('tr').forEach(function (row) {
                            if (row.classList.contains("expanded")) {
                                row.click()
                            }
                        })
                        oTable.order([[].indexOf.call(headers, header), 'desc']).draw()

                        allArrows.forEach(function (arrow) {
                            arrow.style.opacity = '0.3';
                        })
                        downArrow.style.opacity = '1';
                    };
                }
            });


            let modal = document.querySelector(".modal")
            let tableHTML = document.getElementById('table_id')
            $("th:not(:last):not(:first)").click(function (e) {
                eventToHandle = e
                var senderElement = e.target;
                if ($(senderElement).is("th")) {
                    let unorderedList = modal.querySelector('ul')
                    unorderedList.innerHTML = ''
                    modal.style.display = 'block'
                    modal.style.top = senderElement.offsetHeight + 'px';
                    modal.style.left = senderElement.offsetLeft + 'px';
                    modal.style.width = senderElement.offsetWidth + 'px';
                    document.querySelectorAll("th")[0].appendChild(modal);
                    var textList = []
                    if (tableHTML.rows.length > 1) {
                        for (var i = 1; i < tableHTML.rows.length; i++) {
                            var cellData = tableHTML.rows[i].cells[[].indexOf.call(headers, senderElement)].innerHTML
                            var rowElement = tableHTML.rows[i]
                            if (!textList.includes(cellData) && !rowElement.classList.contains('expandedRow') && cellData !== '') {
                                textList.push(cellData)
                                var li = document.createElement("li");
                                li.textContent = cellData;
                                // 
                                let input = document.createElement("input"); //add Input
                                input.type = "checkbox";
                                if (filterSelectionsDict[[].indexOf.call(headers, senderElement)].includes(cellData)) {
                                    input.checked = true;
                                }
                                li.prepend(input);
                                unorderedList.appendChild(li);
                            }

                        }
                    }
                }
                else {
                    console.log("not if")
                }

            });
        });
    }

    function setEndOfTheMonthCheckobox() {
        if (settings_end_of_the_month_payment == 1) {
            document.querySelector(".end_of_the_month_payment input").checked = true;
        }
        else {
            document.querySelector(".end_of_the_month_payment input").checked = false;
        }
    }

    function settingsLoadingStart() {
        document.querySelector("html").classList.add("wait")
    }

    function settingsLoadingSuccess() {
        document.querySelector("html").classList.remove("wait")
        var htmlstring = `<div class="alertMsg" style="
        height: 22px;
        width: 94px;
        position: fixed;
        top: -26px;
        right: 82px;
        background: green;
        padding-left: 21px;
        border-radius: 0 0 15px 15px;
        color: white;
        font-size: 12px;
        line-height: 19px;">Gespeichert!</div>`


        document.querySelector(`body`).insertAdjacentHTML('beforeend', htmlstring);
        document.querySelector(".alertMsg").classList.add("openAlertMessage")
        setTimeout(function () {
            document.querySelector(".alertMsg").style.top = '0px'
        }, 500);
        setTimeout(function () {
            document.querySelector(".alertMsg").classList.remove("openAlertMessage")
            document.querySelector(".alertMsg").classList.add("closeAlertMessage")
        }, 1000);
        setTimeout(function () {
            document.querySelector(".alertMsg").style.top = '-26px'
        }, 1500);

        setTimeout(function () {
            document.querySelector(`.alertMsg`).remove();
        }, 2000);
    }

    function settingsLoadingFail() {
        
        document.querySelector("html").classList.remove("wait")
        var htmlstring = `<div class="alertMsg" style="
        height: 22px;
        width: 127px;
        position: fixed;
        top: -26px;
        right: 82px;
        background: red;
        padding-left: 21px;
        border-radius: 0 0 15px 15px;
        color: white;
        font-size: 12px;
        line-height: 19px;">Nicht gespeichert!</div>`


        document.querySelector(`body`).insertAdjacentHTML('beforeend', htmlstring);
        document.querySelector(".alertMsg").classList.add("openAlertMessage")
        setTimeout(function () {
            document.querySelector(".alertMsg").style.top = '0px'
        }, 500);
        setTimeout(function () {
            document.querySelector(".alertMsg").classList.remove("openAlertMessage")
            document.querySelector(".alertMsg").classList.add("closeAlertMessage")
        }, 1000);
        setTimeout(function () {
            document.querySelector(".alertMsg").style.top = '-26px'
        }, 1500);

        setTimeout(function () {
            document.querySelector(`.alertMsg`).remove();
        }, 2000);
    }

    const SettingsCall = (api_method, value) => {
        if (api_method === "GET") {
            return fetch(api_endpoint + "/retailer?params=" + encodeURIComponent(query), {
                method: api_method,
                mode: "cors",
                headers: {}
            })
            .then(res => res.json())
            .then((result) => {
                if (result.statusCode === 200) {
                    settings_end_of_the_month_payment = result.RetailerAttributes[0].CUST_ATTR_01;
                    monthly_payment_removed_date = result.RetailerAttributes[0].MONTHLY_PAYMENT_REMOVED_DATE;
                    monthly_payment_requested_date = result.RetailerAttributes[0].CUST_ATTR_06;
                }
            });
        } else if (api_method === "POST") {
            let requestBody = { CUST_ATTR_01: value };

            if (value === 0) {
                requestBody.MONTHLY_PAYMENT_REMOVED_DATE = new Date().toISOString().split("T")[0];
            } else if (value === 1) {
                requestBody.CUST_ATTR_06 = new Date().toISOString().split("T")[0];
            }

            if (!query) {
                console.error("Error: query parameter is missing or invalid.");
                return Promise.reject("Missing query");
            }

            // ✅ RETURN the fetch Promise here!
            return fetch(api_endpoint + "/retailer?params=" + encodeURIComponent(query), {
                method: api_method,
                mode: "cors",
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
            .then((res) => res.json())
            .then((result) => {
                if (result.statusCode === 200) {
                    settings_end_of_the_month_payment = value;
                    setEndOfTheMonthCheckobox();
                    settingsLoadingSuccess();
                } else {
                    settingsLoadingFail();
                }
            })
            .catch((error) => {
                console.error("API Error:", error);
                settingsLoadingFail();
            });
        }
    }

    const InvoiceGet = (start_date = startDate, end_date = endDate) => {
        if (unitTestMode) {

            setInvoices(TestInvoices)
            if (functionsFlag === false) {
                const timer = setTimeout(() => {
                    defineTable()
                    defineFunctionsAfterAWSDataCollection()
                }, 1000)
                setFunctionsFlag(true)
            }
            setFunctionsFlag(true)

        }
        else {

            let sd = new Date(sessionStorage.getItem('startDate')).toISOString()
            let ed = new Date(sessionStorage.getItem('endDate')).toISOString()
            fetch(api_endpoint + "/invoices?start_date=" + encodeURIComponent(moment(sd).format('DD-MM-YYYY')) + "&end_date=" + encodeURIComponent(moment(ed).format('DD-MM-YYYY')) + "&params=" + encodeURIComponent(query),
                {
                    method: "GET",
                    mode: "cors",
                    headers: {}
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.statusCode === 200) {
                            setInvoices(result.Invoices)
                            if (functionsFlag === false) {
                                const timer = setTimeout(() => {
                                    defineTable()
                                    defineFunctionsAfterAWSDataCollection()
                                }, 1000)
                                setFunctionsFlag(true)
                            }
                        }
                        else {
                            setInvoices(null)
                            setFunctionsFlag(false)
                        }
                    }
                )
        }
    }

    function DownloadFile(page_url) {
        var element = document.createElement('a');
        element.setAttribute('href', page_url);
        element.setAttribute('download', "x");
        element.setAttribute('target', "_blank");
        document.body.appendChild(element);
        element.click();
    }

    const DownloadInvoice = (INVOICE_NAME, INVOICE_ID) => {
        var data = {
            'INVOICE_NAME': INVOICE_NAME,
            'params': query,
            'INVOICE_ID': INVOICE_ID
        }
        fetch(api_endpoint + "/invoices", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(res => res.json())
            .then(
                (result) => {
                    DownloadFile(result["body"]);
                    // alert('Link for invoice: ' + INVOICE_NAME + ' has been generated. Will be valid for next 30 minutes.')
                }
            )
    }

    function handleClick(event, invoiceIndex) {
        var index = event.currentTarget.rowIndex
        var mainTable = document.querySelector("table");
        var originalRow = mainTable.querySelectorAll("tr")[index]
        var arrow = originalRow.querySelector('span')
        if (originalRow.classList.contains('expanded')) {
            while (mainTable.querySelectorAll("tr")[index + 1] && mainTable.querySelectorAll("tr")[index + 1].classList.contains("expandedRow")) {
                mainTable.deleteRow(index + 1);
            }
            originalRow.classList.remove("expanded")
            arrow.style.transform = 'rotate(-90deg)';
        }
        else {
            arrow.style.transform = 'rotate(0deg)';
            originalRow.classList.add("expanded");
            var nested_lines_id = 0;
            while (invoices[invoiceIndex].nested_lines[nested_lines_id]) {

                var row = mainTable.insertRow(index + 1);
                row.style.backgroundColor = "#EDEDF2";
                var cell0 = row.insertCell(0);
                var cell1 = row.insertCell(1);
                var cell2 = row.insertCell(2);
                var cell3 = row.insertCell(3);
                var cell4 = row.insertCell(4);
                var cell5 = row.insertCell(5);
                row.classList.add('expandedRow')
                row.style.height = '0';

                cell0.classList.add("hideToPrint")
                cell0.innerHTML = "";
                cell4.innerHTML = "";
                cell5.innerHTML = "";
                cell5.classList.add("hideToPrint")
                if (invoices[invoiceIndex].nested_lines[nested_lines_id].PAYMENT_TIMESTAMP !== null) {

                    cell1.textContent = invoices[invoiceIndex].nested_lines[nested_lines_id].PAYMENT_TIMESTAMP;
                    cell2.textContent = invoices[invoiceIndex].nested_lines[nested_lines_id].PAYMENT_DESCRIPTION;
                    cell3.textContent = invoices[invoiceIndex].nested_lines[nested_lines_id].VALUE.toFixed(2);  


                    row.style.height = 'auto';
                }

                row.style.textAlign = 'center';

                var row = mainTable.insertRow(index + 2);
                var cell0 = row.insertCell(0);
                var cell1 = row.insertCell(1);
                var cell2 = row.insertCell(2);
                var cell3 = row.insertCell(3);
                var cell4 = row.insertCell(4);
                var cell5 = row.insertCell(5);
                row.classList.add('expandedRow')
                row.style.height = '0';
                cell0.classList.add("hideToPrint")
                cell0.innerHTML = "";
                cell4.innerHTML = "";
                cell5.innerHTML = "";
                cell5.classList.add("hideToPrint")

                cell1.textContent = "Kundennummer: ";
                const customerSpan = document.createElement("span");
                customerSpan.className = "notBold";
                customerSpan.textContent = invoices[invoiceIndex].nested_lines[nested_lines_id].CUSTOMER_CODE;
                cell1.appendChild(customerSpan);

                cell1.appendChild(document.createElement("br"));

                cell1.appendChild(document.createTextNode("Quelle: "));
                const sourceSpan = document.createElement("span");
                sourceSpan.className = "notBold";
                sourceSpan.textContent = invoices[invoiceIndex].nested_lines[nested_lines_id].SOURCE_SYSTEM_NAME;
                cell1.appendChild(sourceSpan);


                cell2.textContent = "Zahlungs ID: ";
                const paymentIdSpan = document.createElement("span");
                paymentIdSpan.className = "notBold";
                paymentIdSpan.textContent = invoices[invoiceIndex].nested_lines[nested_lines_id].PAYMENT_ID;
                cell2.appendChild(paymentIdSpan);

                cell2.appendChild(document.createElement("br"));

                cell2.appendChild(document.createTextNode("Zahlungsgrund: "));
                const reasonSpan = document.createElement("span");
                reasonSpan.className = "notBold";
                reasonSpan.textContent = invoices[invoiceIndex].nested_lines[nested_lines_id].PAYMENT_REASON;
                cell2.appendChild(reasonSpan);
    
                cell3.textContent = "Details: ";
                const commentSpan = document.createElement("span");
                commentSpan.className = "notBold";
                commentSpan.textContent =
                invoices[invoiceIndex].nested_lines[nested_lines_id].PAYMENT_COMMENT ?? "";
                cell3.appendChild(commentSpan);    


                
                row.style.height = 'auto';
                row.style.textAlign = 'center';
                nested_lines_id++;
            }
        }
    }


       
    function defineFunctionsAfterAWSDataCollection() {
        var headers = document.querySelectorAll("th")

        function clearFilter() {
            closeModal();
            filterSelectionsDict = { 0: [], 1: [], 2: [], 3: [], 4: [] };

            document.querySelector('tbody').querySelectorAll('tr').forEach(function (row) {
                if (row.classList.contains("expanded")) {
                    row.click();
                }
            });

            oTable.columns().search("").draw();
            oTable.search("").draw();

            sessionStorage.setItem('startDate', moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).subtract(4, 'week'));
            sessionStorage.setItem('endDate', moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }));
            window.location.reload();
        }

        function defineSettings(monthly_payment_removed_date, monthly_payment_requested_date, settings_end_of_the_month_payment) {
            var settingsContainer = document.createElement("div");
            settingsContainer.classList.add("settings_container");

            //settingsContainer.style.position = "absolute";
            //settingsContainer.style.left = "calc(100% - 58px)";
            //settingsContainer.style.width = "fit-content";
            //settingsContainer.style.zIndex = '1';

            settingsContainer.style.display = "inline-flex";
            settingsContainer.style.alignItems = "center";
            settingsContainer.style.gap = "4px";
            settingsContainer.style.width = "fit-content";
            settingsContainer.style.zIndex = '1';
        
            var settingsList = document.createElement("ul");
            settingsList.classList.add("settings_list");
            settingsList.style.listStyleType = "none";
            settingsList.style.paddingLeft = "0px";
            settingsList.style.marginTop = "0px";
            settingsList.style.marginBottom = "0px";
            settingsList.style.marginLeft = "10px";
            settingsList.style.marginRight = "10px";
        
     
            let isLocked = false

            if (monthly_payment_removed_date) {
                let removedDate = new Date(monthly_payment_removed_date);
                let currentDate = new Date();
                
                if (
                    removedDate.getFullYear() === currentDate.getFullYear() &&
                    removedDate.getMonth() === currentDate.getMonth()
                ) {
                    isLocked = true;
                }
            }
            var setting_end_of_the_month_pay_tooltip = document.createElement("div");
            setting_end_of_the_month_pay_tooltip.classList.add("tooltip2");
        
            var setting_end_of_the_month_pay_tooltip_text = document.createElement("span");
            setting_end_of_the_month_pay_tooltip_text.classList.add("tooltiptext2");
            

            console.log(monthly_payment_requested_date);
            const reqdate = new Date(monthly_payment_requested_date);
            const deadate = new Date(monthly_payment_removed_date);
            const ReqformattedDate = `${reqdate.getDate().toString().padStart(2, '0')}/${(reqdate.getMonth() + 1).toString().padStart(2, '0')}/${reqdate.getFullYear()}`;
            const DeactformatedDate = `${deadate.getDate().toString().padStart(2, '0')}/${(deadate.getMonth() + 1).toString().padStart(2, '0')}/${deadate.getFullYear()}`;

            if (isLocked) {
                setting_end_of_the_month_pay_tooltip_text.innerText = `Die Option ‚Monatliche Auszahlung‘ wurde\n deaktiviert. \nAusgewählt am: ${DeactformatedDate}`;
                setting_end_of_the_month_pay_tooltip_text.style.backgroundColor = "background: #21305E";
                setting_end_of_the_month_pay_tooltip_text.style.color = "#FFFFFF";
                setting_end_of_the_month_pay_tooltip_text.style.height = "80px";
            } 
            
            else if (monthly_payment_requested_date === 0)
            {
                setting_end_of_the_month_pay_tooltip_text.innerText = "Aktivieren Sie 'Monatliche Auszahlung', um eine gesammelte Auszahlung am Ende jeden Monats zu erhalten. Die Einzelbeträge werden in Ihrem Beleg aufgeführt. Diese Änderung wird für all Ihre Geschäfte übernommen.";
                setting_end_of_the_month_pay_tooltip_text.style.height = "95px";
            
            }
                else
             {
                
                setting_end_of_the_month_pay_tooltip_text.innerText = `Die Option‚ Monatliche Auszahlung‘ ist aktiviert. Ihre Zahlungen werden gesammelt und zum Monatsende ausgezahlt. Bitte beachten Sie, dass die Überweisung am letzten Tag des Monats veranlasst wird, aber die Gutschrift je nach Bankverbindung erst zu Beginn des folgenden Monats auf Ihrem Konto erscheinen kann.\n Ausgewählt am: ${ReqformattedDate}`;
            }
            
        
            setting_end_of_the_month_pay_tooltip.appendChild(setting_end_of_the_month_pay_tooltip_text);
        
            var setting_end_of_the_month_pay = document.createElement("li");
            setting_end_of_the_month_pay.classList.add("end_of_the_month_payment");
        
            var setting_end_of_the_month_pay_p = document.createElement("p");
            setting_end_of_the_month_pay_p.innerText = "Monatliche Auszahlung";
            setting_end_of_the_month_pay_p.style.display = "inline-block";
            setting_end_of_the_month_pay_p.style.marginRight = "15px";
            setting_end_of_the_month_pay_p.style.marginLeft = "7px";
        

            var setting_end_of_the_month_pay_checkbox = document.createElement("input");
            setting_end_of_the_month_pay_checkbox.type = "checkbox";
            setting_end_of_the_month_pay_checkbox.style.scale = "1.5";

            var checkboxWrapper = document.createElement("div");
            checkboxWrapper.style.display = "inline-block";
            checkboxWrapper.style.position = "relative";
            checkboxWrapper.style.cursor = "pointer";

            checkboxWrapper.appendChild(setting_end_of_the_month_pay_checkbox);
            
            if (isLocked) {

                setting_end_of_the_month_pay_checkbox.disabled = true;

                setting_end_of_the_month_pay_checkbox.style.pointerEvents = "none"; 


                checkboxWrapper.addEventListener("click", function () {
                    showModal(
                        "<h2>Änderungslimit erreicht</h2><p>Sie haben Ihre Zahlungsoption in diesem Monat bereits geändert. Um die Stabilität Ihres Abrechnungszyklus zu gewährleisten, beschränken wir die Anzahl der Änderungen in diesem Monat. Bitte warten Sie bis zum ersten Tag des nächsten Monats, wenn Sie weitere Änderungen vornehmen möchten. <br><br>Vielen Dank für Ihr Verständnis.</p>",
                                                  
                        function () {
                            customModal.style.display = "none";
                        },

                        function () {
                            customModal.style.display = "none";
                        }
                        
            
                        

                    );

                    // Wait for modal to render, then adjust styles
                    setTimeout(() => {
                        const cancelBtn = document.getElementById("cancelBtn");
                        if (cancelBtn) cancelBtn.style.display = "none";

                        const confirmBtn = document.getElementById("confirmBtn");
                        if (confirmBtn) confirmBtn.innerText = "Schließen";

                        const modalContent = document.querySelector(".custom-modal .modal-content");
                        if (modalContent) {
                            modalContent.style.height = "390px";
                            modalContent.style.width = "471px";
                        }
                        
                    }, 50);

                });
            }

            // ✅ Append the wrapper instead of the checkbox directly
            setting_end_of_the_month_pay.appendChild(checkboxWrapper);
            setting_end_of_the_month_pay.appendChild(setting_end_of_the_month_pay_p);
            setting_end_of_the_month_pay.appendChild(setting_end_of_the_month_pay_tooltip);

            settingsList.appendChild(setting_end_of_the_month_pay);
            settingsContainer.appendChild(settingsList);
            document.querySelector(".topButtons").appendChild(settingsContainer);

            
            if (monthly_payment_requested_date && settings_end_of_the_month_payment === 1) {
                var populatedMessage = document.createElement("p");
                
                //populatedMessage.innerText = `Die Option‚ Monatliche Auszahlung‘ ist aktiviert. Ihre Zahlungen werden gesammelt und zum Monatsende ausgezahlt. \n Bitte beachten Sie, dass die Überweisung am letzten Tag des Monats veranlasst wird, \n aber die Gutschrift je nach Bankverbindung erst zu Beginn des folgenden Monats auf Ihrem Konto erscheinen kann. Ausgewählt am:  ${new Date(monthly_payment_requested_date).toLocaleDateString()}`;
                populatedMessage.style.color = "#28a745";  // Green color for the message
                populatedMessage.style.fontSize = "14px";
                populatedMessage.style.marginTop = "5px";
                
                // Append the message under the checkbox
                setting_end_of_the_month_pay.appendChild(populatedMessage);
            }

            var customModal = document.createElement("div");
            customModal.classList.add("custom-modal");
            customModal.innerHTML = `
                 <div class="modal-content">
                <span class="close-btn" id="modalCloseBtn">&times;</span>
                <div id="modalMessage" class="modal-message"></div>
                <div class="modal-buttons">
                <button id="cancelBtn">Abbrechen</button>
                <button id="confirmBtn">Zustimmen</button>
                
                </div>
            </div>
            `;
            document.body.appendChild(customModal);

            var style = document.createElement("style");
            style.innerHTML = `

                    .modal {
                    display: none;
                    position: fixed;
                    z-index: 1000;
                    left: 0; top: 0;
                    width: 100%; height: 100%;
                    background-color: rgba(0, 0, 0, 0.6);
                    justify-content: center;
                    align-items: center;
                    }
        

                    .modal-content {
                    background-color: #fff;
                    padding: 30px 30px 0px 30px;
                    width: 471px; /* Custom size */
                    height: 309px;
                    font-weight: 400;
                    border-radius: 20px;
                    position: relative;
                    text-align: left; /* Right-align text */
                    }

                    .modal-message {
                    text-align: left; /* Also right-align the inner text */
                    margin-bottom: 20px;
                    
                    }

                    .modal-buttons {
                    text-align: center;
                    border-radius: 10px 10px 10px

                    }
                

                    .close-btn {
                    position: absolute;
                    top: 10px; right: 15px;
                    font-size: 22px;
                    cursor: pointer;
                    color: #aaa;
                    }

                    .close-btn:hover {
                    color: #333;
                    }

                .custom-modal {
                    display: none;
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.5);
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                }

                .modal-content button {
                    margin: 10px;
                    padding: 20px;
                    font-family: 'Open Sans';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 14px !important;
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                    border-bottom-left-radius: 10px;
                    border-bottom-right-radius: 0;
                    border: none;
                    color: #413A00;
                    cursor: pointer;
                }
                #confirmBtn {
                    background-color: #EFD600;
                    width: 177px;
                    height: 44px;
                    padding: 0px 16px 0px 16px;
                    color: #413A00;
                }
                #confirmBtn:hover {
                    background-color: #EFD600;
                }
                #cancelBtn {
                    background-color: #ECF9FD;                    
                    width: 177px;
                    height: 44px;
                    padding: 0px 16px 0px 16px;
                    color: #123946;
                }
                #cancelBtn:hover {
                    background-color: #ECF9FD;
                }
            `;
            document.head.appendChild(style);
        
            // 🎭 Function to Show Modal
            function showModal(message, onConfirm, onCancel) {
                document.getElementById("modalMessage").innerHTML = message;
                customModal.style.display = "flex";
        
                document.getElementById("confirmBtn").onclick = function() {
                    customModal.style.display = "none";
                    onConfirm();
                };
        
                document.getElementById("cancelBtn").onclick = function() {
                    customModal.style.display = "none";
                    onCancel();
                };

                document.getElementById("modalCloseBtn").onclick = function() {
                    customModal.style.display = "none";
                    onCancel(); // Optional: trigger cancel callback
                };


            }
        
            function showSecondModal(message, onConfirm) {
                document.getElementById("modalMessage").innerHTML  = message;
                customModal.style.display = "flex";
            
                document.getElementById("confirmBtn").innerHTML = "Schließen";
            
                // Combine both actions in one event handler
                document.getElementById("confirmBtn").onclick = function() {
                    customModal.style.display = "none";  // Close the modal
                    window.location.reload();  // Refresh the page
                };
            
                // Hide the cancel button for this modal
                document.getElementById("cancelBtn").style.display = "none";
            }
            

            setting_end_of_the_month_pay_checkbox.addEventListener('change', (event) => {
                if (!isLocked) {
                    if (event.currentTarget.checked) {
                        // ENABLE Monthly Payment
                        showModal(
                            "<h2>Wichtiger Hinweis</h2><p>Sind Sie damit einverstanden, dass alle fälligen Zahlungen am Monatsende angewiesen werden?<br>Bitte beachten Sie, dass die Gutschrift auf Ihrem Konto zu Beginn des nächsten Monats erfolgen kann.<br>Wir danken Ihnen für Ihr Verständnis und Ihre Flexibilität!</p>",
                            function confirmEnable() {
                                settingsLoadingStart();

                                SettingsCall("POST", 1)
                                    .then(() => {
                                        setTimeout(() => window.location.reload(), 500); // refresh after DB update
                                    })
                                    .catch((error) => {
                                        console.error("Settings update failed:", error);
                                        settingsLoadingFail();
                                    });
                            },
                            function cancelEnable() {
                                setting_end_of_the_month_pay_checkbox.checked = false;
                            }
                        );
                    } else {
                        // DISABLE Monthly Payment
                        document.getElementById("cancelBtn").style.display = "none";
                        showModal(
                            "<h2>Wichtiger Hinweis</h2><p>Sind Sie sicher, dass Sie die monatliche Zahlung aufheben möchten?<br><br>Bitte beachten Sie, dass Sie diese Auswahl nur einmal pro Monat rückgängig machen können und die Änderung für all Ihre Geschäfte übernommen wird.</p>",
                            function confirmDisable() {
                                settingsLoadingStart();

                                SettingsCall("POST", 0)
                                    .then(() => {
                                        showSecondModal(
                                            "<h2>Wichtiger Hinweis</h2><p>Sie haben zur regulären Zahlung gewechselt. <br><br>Ihre aktuellen, geparkten Auszahlungen werden nun innerhalb von 5 Werktagen bearbeitet."
                                        );
                                    })
                                    .catch((error) => {
                                        console.error("Settings update failed:", error);
                                        settingsLoadingFail();
                                    });
                            },
                            function cancelDisable() {
                                setting_end_of_the_month_pay_checkbox.checked = true;
                            }
                        );
                    }
                }
            });
        
            setEndOfTheMonthCheckobox();
        }
        
        
        
        
        
        
        

        function open_close_settings() {
            var displ = document.querySelector(".settings_container").style.display
            if (displ === "none") {
                document.querySelector(".settings_container").style.display = "block"
            }
            else {
                document.querySelector(".settings_container").style.display = "none"
            }

        }

        


            // sessionStorage.setItem('startDate', (moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(3,'month')));
            // sessionStorage.setItem('endDate', (moment().set({hour:0,minute:0,second:0,millisecond:0})));
            // if(
            //   new Date(moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(3,'month')).getTime() >= new Date(moment(sessionStorage.getItem('startDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime() &&
            //   new Date(moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(3,'month')).getTime() <= new Date(moment(sessionStorage.getItem('endDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime() &&
            //   new Date(moment().set({hour:0,minute:0,second:0,millisecond:0})).getTime() >= new Date(moment(sessionStorage.getItem('startDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime() &&
            //   new Date(moment().set({hour:0,minute:0,second:0,millisecond:0})).getTime() <= new Date(moment(sessionStorage.getItem('endDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime())
            // {

            //   $('input[name="daterange"]').data('daterangepicker').setStartDate(moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(3,'month').format('DD-MM-YYYY'));
            //   $('input[name="daterange"]').data('daterangepicker').setEndDate(moment().set({hour:0,minute:0,second:0,millisecond:0}).format('DD-MM-YYYY'));
            //   document.querySelector('.daterangepicker button.applyBtn').click()
            //   // console.log(new Date(moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(3,'month')).getTime())
            // }
            // else{
            //   alert("refresh")
            //   window.location.reload();
            // }

        //}


        function clearColumnFilter() {
            document.querySelector('tbody').querySelectorAll('tr').forEach(function (row) {
                if (row.classList.contains("expanded")) {
                    row.click()
                }
            })
            oTable.column([].indexOf.call(headers, eventToHandle.target)).search('').draw();
            filterSelectionsDict[[].indexOf.call(headers, eventToHandle.target)] = []
            document.querySelectorAll('th')[[].indexOf.call(headers, eventToHandle.target)].click()
        }

        function filterModal() {
            var unorderedList = document.querySelector('ul')
            var listItems = document.querySelectorAll('li')
            document.querySelector('tbody').querySelectorAll('tr').forEach(function (row) {
                if (row.classList.contains("expanded")) {
                    row.click()
                }
            })
            var filterList = []
            listItems.forEach(function (listItem) {
                if (listItem.querySelector('input').checked) {
                    filterList.push(listItem.innerText)
                }
            });
            filterSelectionsDict[[].indexOf.call(headers, eventToHandle.target)] = filterList
            oTable.column([].indexOf.call(headers, eventToHandle.target)).search(filterList.join('|'), false, false).draw();
            document.querySelector(".modal").style.display = 'none'
            unorderedList.innerHTML = '';
        }

        function closeModal() {
            document.querySelector(".modal").style.display = 'none'
        }


        function printTable() {
            document.querySelector('tbody').querySelectorAll('tr').forEach(function (row) {
                if (!row.classList.contains("expanded")) {
                    row.click()
                }

            });
            document.querySelector('tbody').querySelectorAll('.expanded td').forEach(function (row) {
                row.style.borderTop = '1px solid black'
            });
            document.querySelector('tbody').querySelectorAll('.expandedRow td').forEach(function (row) {
                row.style.borderBottom = '1px solid black'
            });

            document.querySelector('#table_id_filter').style.display = 'none'

            document.querySelectorAll('.hideToPrint').forEach(function (elementToHide) {
                elementToHide.style.setProperty('display', 'none', 'important')
            });
            document.querySelectorAll('tr:nth-child(12n)').forEach(function (nth) {
                nth.style.pageBreakAfter = "always";
            });


            window.print()

            document.querySelector('tbody').querySelectorAll('.expanded td').forEach(function (row) {
                row.style.borderTop = 'none'
            });
            document.querySelector('tbody').querySelectorAll('.expandedRow td').forEach(function (row) {
                row.style.borderBottom = 'none'
            });
            document.querySelector('#clearFilterButton').style.display = 'block'

            document.querySelector('#printTableButton').style.display = 'block'

            //document.querySelector('#table_id_filter').style.display = 'block'

            document.querySelectorAll('.sorter').forEach(function (sorter) {
                sorter.style.display = 'block'
            });
            document.querySelectorAll('.hideToPrint').forEach(function (elementToHide) {
                elementToHide.style.removeProperty('display');
            });
            document.querySelector('tbody').querySelectorAll('.expanded').forEach(function (row) {
                if (row.classList.contains("expanded")) {
                    row.click()
                }
            });
        }

        $('input[name="daterange"]').daterangepicker({
            opens: 'left',
            locale: {
                format: 'DD.MM.YYYY',
                applyLabel: "Anwenden",
                cancelLabel: "Abbrechen",
                daysOfWeek: [
                    "So",
                    "Mo",
                    "Di",
                    "Mi",
                    "Do",
                    "Fr",
                    "Sa"
                ],
                monthNames: [
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                ],
                "firstDay": 1
            }
        })

        $('input[name="daterange"]').on('apply.daterangepicker', function (ev, picker) {
            {

                var start = picker.startDate;
                var end = picker.endDate;
                // console.log(new Date(moment(start).set({hour:0,minute:0,second:0,millisecond:0})).getTime())
                // console.log(new Date(moment(sessionStorage.getItem('startDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime())
                // console.log(new Date(moment(start).set({hour:0,minute:0,second:0,millisecond:0})).getTime()>= new Date(moment(sessionStorage.getItem('startDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime())
                // console.log(new Date(moment(start).set({hour:0,minute:0,second:0,millisecond:0})).getTime() <= new Date(moment(sessionStorage.getItem('endDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime())
                // console.log(new Date(moment(end).set({hour:0,minute:0,second:0,millisecond:0})).getTime() >= new Date(moment(sessionStorage.getItem('startDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime())
                // console.log(new Date(moment(end).set({hour:0,minute:0,second:0,millisecond:0})).getTime() <= new Date(moment(sessionStorage.getItem('endDate')).set({hour:0,minute:0,second:0,millisecond:0})).getTime())

                if (
                    new Date(moment(start).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime() >= new Date(moment(sessionStorage.getItem('startDate')).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime() &&
                    new Date(moment(start).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime() <= new Date(moment(sessionStorage.getItem('endDate')).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime() &&
                    new Date(moment(end).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime() >= new Date(moment(sessionStorage.getItem('startDate')).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime() &&
                    new Date(moment(end).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime() <= new Date(moment(sessionStorage.getItem('endDate')).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).getTime()) {
                    // this takes data from cache if new range fits inside first downloaded range
                    // alert("in rage not downloading data")
                    // sessionStorage.setItem('startDate', start);
                    // sessionStorage.setItem('endDate', end);
                    // function getDatesInRange(startDate, endDate) {
                    //   const date = new Date(startDate.getTime());

                    //   const dates = [];

                    //   while (date <= endDate) {
                    //     dates.push(new Date(date).toLocaleDateString("de-DE"));
                    //     date.setDate(date.getDate() + 1);
                    //   }
                    //   return dates; 
                    // }
                    // console.log(start)
                    // console.log(end)
                    // console.log(getDatesInRange(new Date(start),new Date(end)).join('|'))
                    // oTable.column(1).search( getDatesInRange(new Date(start),new Date(end)).join('|'), true).draw();
                    sessionStorage.setItem('startDate', start);
                    sessionStorage.setItem('endDate', end);
                    let sd = new Date(sessionStorage.getItem('startDate')).toISOString()
                    let ed = new Date(sessionStorage.getItem('endDate')).toISOString()
                    moment(sd).format('DD-MM-YYYY')
                    moment(ed).format('DD-MM-YYYY')
                    window.location.reload();


                }
                else {
                    // alert("downloading data")
                    sessionStorage.setItem('startDate', start);
                    sessionStorage.setItem('endDate', end);
                    let sd = new Date(sessionStorage.getItem('startDate')).toISOString()
                    let ed = new Date(sessionStorage.getItem('endDate')).toISOString()
                    moment(sd).format('DD-MM-YYYY')
                    moment(ed).format('DD-MM-YYYY')
                    window.location.reload();
                }
            }
        }
        )

        let sd = new Date(sessionStorage.getItem('startDate')).toISOString()
        let ed = new Date(sessionStorage.getItem('endDate')).toISOString()
        $('input[name="daterange"]').data('daterangepicker').setStartDate(moment(sd).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('DD-MM-YYYY'));
        $('input[name="daterange"]').data('daterangepicker').setEndDate(moment(ed).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('DD-MM-YYYY'));
        defineSettings(monthly_payment_removed_date, monthly_payment_requested_date, settings_end_of_the_month_payment)
        document.querySelector("#modalCloseButton").addEventListener("click", closeModal);
        document.querySelector("#modalFilterButton").removeEventListener("click", filterModal);
        document.querySelector("#modalFilterButton").addEventListener("click", filterModal);
        document.querySelector("#clearFilterButton").addEventListener("click", clearFilter);
        // document.querySelector("#openSettingsButton").addEventListener("click", open_close_settings);
        document.querySelector("#printTableButton").addEventListener("click", printTable);
        document.querySelector("#modalClearColumnFilterButton").addEventListener("click", clearColumnFilter);
        document.addEventListener('click', function handleClickOutsideBox(event) {
            const box = document.querySelector('.modal');
            const theadBox = document.querySelector('thead');

            if (!box.contains(event.target) && !theadBox.contains(event.target)) {
                closeModal()
            }
            else {
            }
        });


    }

    // if (loading) {
    //     return (
    //         <div className='loader'></div>
    //     );
    // }

    if (vars.length !== 1 || query == null || invoices === null) {
        return (
            <div className={classes.root}>
                <Container className={classes.container}>
                    <Paper className={classes.paper}>
                        <Box display="flex">
                            <Box flexGrow={1}>
                                <Typography component="h3" variant="h6" color="primary" gutterBottom>
                                    400 ERROR
                                </Typography>
                            </Box>
                        </Box>
                        <Box flexGrow={1}>
                            <Typography component="h2" variant="h6" color="secondary" gutterBottom>
                                Request will not be processed.
                            </Typography>
                        </Box>
                        <Box flexGrow={1}>
                            <Typography component="p" variant="h6" color="secondary" gutterBottom>
                                Request parameters missing or values different than expected.
                            </Typography>
                        </Box>
                    </Paper>
                </Container>
            </div>
        );
    }
    else {
        return (
            <div className={classes.root}>
                <Container className={classes.container}>



                    <div className="header-text">
                        <span id="standText" className="hideToPrint">
                        Stand: {new Date().toLocaleDateString('de-DE')}
                        </span>

                

                        <button id="printTableButton"className="hideToPrint"
  style={{
    backgroundImage: `url(${printIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    width: '32px',
    height: '32px',
    border: 'none',
    cursor: 'pointer',
  }}
/>
                       
                    </div>




                    <div className="topButtons hideToPrint">
                        {/* &#x1F4C5; */}
                      
                        
                          <div className="date-range-container">
                            <label id="invoicesText" className="hideToPrint">Auszahlungen</label>
    
                           


                            <div className="date-range-box">
                                <label for="date-range-input">Zeitraum auswählen</label>
                                <input
                                type="text"
                                name="daterange"
                                className="daterange-input"
                                
                                readOnly
                                />
 
                            </div>

                 
                            <div class="search-container">
                                <label for="search-input">Suche</label>
                            <input type="text" placeholder="" class="custom-search-input"/>
        
                        </div>
                        
                            </div>

                        <button id="clearFilterButton" className="hideToPrint">Filter zurücksetzen</button>
                    </div>

                   
                     
                    <Paper className={classes.paper}>
                      
                        <TableContainer component={Paper}>
                           
                            <Table className={classes.table} aria-label="simple table" id='table_id'>
                                 
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="hideToPrint"> </TableCell>
                                        <TableCell align="center">Verarbeitungsdatum
                                            <button className="sorter sortUp hideToPrint"></button>
                                            <button className="sorter sortDown hideToPrint"></button>
                                        </TableCell>
                                        <TableCell align="center">Beschreibung
                                            <button className="sorter sortUp hideToPrint"></button>
                                            <button className="sorter sortDown hideToPrint"></button>
                                        </TableCell>
                                        <TableCell align="center">Betrag €
                                            <button className="sorter sortUp hideToPrint"></button>
                                            <button className="sorter sortDown hideToPrint"></button>
                                        </TableCell>
                                        <TableCell align="center">Status
                                            <button className="sorter sortUp hideToPrint"></button>
                                            <button className="sorter sortDown hideToPrint"></button>
                                        </TableCell>
                                        <TableCell align="center" className="hideToPrint">Beleg (PDF)</TableCell>
                                        <TableCell align="center" className="hideToPrint"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoices.length === 0 ? <div className="loader"></div> : <div></div>}
                                    {invoices.map((invoice, index) => (
                                        <TableRow key={invoice.PAYMENT_ID} id={invoice.PAYMENT_ID} onClick={event => handleClick(event, index)}>
                                            <TableCell align="center" className="hideToPrint"><span className='arrowIcon'></span></TableCell>
                                            {/* <TableCell align="center"> data-sort={invoice.PAYMENT_TIMESTAMP.split("-")}{invoice.PAYMENT_TIMESTAMP}</TableCell> */}
                                            {/* <TableCell align="center">{new Date(invoice.PAYMENT_TIMESTAMP).toLocaleDateString('sv')}</TableCell> */}
                                            {/* <TableCell align="center" data-order={moment(new Date(invoice.PAYMENT_TIMESTAMP)).format('YYYY-MM-DD')}>{invoice.PAYMENT_TIMESTAMP}</TableCell> */}
                                            {/* <TableCell align="center" data-sort={invoice.PAYMENT_TIMESTAMP ? invoice.PAYMENT_TIMESTAMP.split('-')[1]+"-"+invoice.PAYMENT_TIMESTAMP.split('-')[0]+"-"+invoice.PAYMENT_TIMESTAMP.split('-')[2] : invoice.PAYMENT_TIMESTAMP}>{invoice.PAYMENT_TIMESTAMP}</TableCell> */}
                                            <TableCell align="center" data-sort={invoice.main_line.PAYMENT_TIMESTAMP ? new Date(invoice.main_line.PAYMENT_TIMESTAMP.split('-')[1] + "-" + invoice.main_line.PAYMENT_TIMESTAMP.split('-')[0] + "-" + invoice.main_line.PAYMENT_TIMESTAMP.split('-')[2]).toLocaleDateString('sv') : invoice.main_line.PAYMENT_TIMESTAMP}>{(invoice.main_line.PAYMENT_TIMESTAMP) ? invoice.main_line.PAYMENT_TIMESTAMP.replaceAll('-', '.') : ''}</TableCell>
                                            <TableCell align="center">{invoice.nested_lines[0].INVOICE_ID_RAW ? invoice.nested_lines[0].INVOICE_ID_RAW : invoice.main_line.PAYMENT_DESCRIPTION}</TableCell>
                                            <TableCell align="center">{(invoice.main_line.VALUE === 0) ? "" : invoice.main_line.VALUE.toFixed(2)}</TableCell>
                                            <TableCell align="center">{invoice.main_line.AUTH_STATUS}</TableCell>
                                            <TableCell align="center" className="hideToPrint">
                                                <ButtonGroup aria-label="outlined primary button group">
                                                    ${invoice.main_line.IS_FILE_EXIST !== null
                                                        ? <Button id={invoice.nested_lines[0].INVOICE_NAME} className="downloadButton"
                                                            onClick={() => DownloadInvoice(invoice.nested_lines[0].INVOICE_NAME, invoice.nested_lines[0].INVOICE_ID)}>
                                                            <span className='downloadIcon'></span></Button> :
                                                        <Button className="invisibleButton" id={invoice.nested_lines[0].INVOICE_NAME}> </Button>}
                                                </ButtonGroup>
                                            </TableCell>
                                            <TableCell id='last' align="center">
                                                {invoice.PAYMENT_TIMESTAMP},
                                                {invoice.CUSTOMER_CODE},
                                                {invoice.SOURCE_SYSTEM_NAME},
                                                {invoice.PAYMENT_ID},
                                                {invoice.PAYMENT_REASON},
                                                {invoice.PAYMENT_DESCRIPTION},
                                                {invoice.PAYMENT_COMMENT},
                                                {invoice.VALUE},
                                                {invoice.AUTH_STATUS}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Container>
                <div className="modal">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-title">Filter</div>
                            </div>
                            <div className="modal-body">
                                <ul ></ul>
                            </div>
                            <div className="modal-footer">

                                <button id="modalFilterButton" type="button">Filter</button>
                                <button id="modalClearColumnFilterButton" type="button">Reinigen</button>
                                <button id="modalCloseButton" type="button" data-bs-dismiss="modal">Schließen</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div onClick={testFunction()}></div> */}
            </div>
        );
    }
}
